import React, { FunctionComponent, useState } from 'react';
import { Grid, Paper, Tab, Tabs } from '@mui/material';
import { Page } from '../../../../../components/Layout';
import SwipeableViews from 'react-swipeable-views';
import LocationInspectionData from './Components/LocationInspectionData/LocationInspectionData';
import OrderedInspections from './Components/OrderedInspections/OrderedInspections';
import { ReportingTabProps } from '../../../../../types/reporting.type';

const Inspections: FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const [tabValue, setTabValue] = useState<number>(0);

    return (
        <>
            <Grid item xs={10}>
                <Page>
                    <Paper square style={{ width: 'fit-content', marginBottom: '18px' }}>
                        <Tabs
                            value={tabValue}
                            indicatorColor={'secondary'}
                            textColor={'inherit'}
                            onChange={(e, v) => setTabValue(v)}
                            aria-label="agent submission secondary tabs"
                            variant={'scrollable'}
                            scrollButtons={'auto'}
                        >
                            <Tab label={'Location Inspection Data'} />
                            <Tab label={'Ordered Inspections'} />
                        </Tabs>
                    </Paper>
                    <SwipeableViews index={tabValue} onChangeIndex={(val) => setTabValue(val)}>
                        <LocationInspectionData />
                        <OrderedInspections />
                    </SwipeableViews>
                </Page>
            </Grid>
        </>
    );
};

export default Inspections;
